import React, { useEffect } from "react";
import { Helmet } from "@dr.pogodin/react-helmet";

export default function RefundPolicy() {
  useEffect(() => {
      document.title = "Our Returns and Refund Policy| Disclaimer";
    }, []);
  return (
    <>
      <Helmet>
        <title>Our Returns and Refund Policy| Disclaimer</title>
        <meta name="description" content="Learn about InfinitiveHost's refund policy to ensure a hassle-free hosting experience. Discover our transparent approach and commitment to customer satisfaction." />
        <meta name="keywords" content="refund policy, return policy, refund process, cancellation policy, refund terms, return authorization, money-back guarantee, refund eligibility" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/refund-policy`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/refund-policy`} />
        <meta property="og:title" content="Our Returns and Refund Policy| Disclaimer" />
        <meta property="og:description" content="Learn about InfinitiveHost's refund policy to ensure a hassle-free hosting experience. Discover our transparent approach and commitment to customer satisfaction." />
      </Helmet>
      <div className="banner-bg pt-pb-100-banner bg-dark">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xxl-8 col-xl-8">
              <div className="text-center">
                  <span className="fs-18 fw-bold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Refund</span>
                  <h1 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    Refund Policy
                    </h1>
                  <p className="text-white mb-8 max-text-60 mx-auto text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    Shop with confidence knowing that we stand behind our products. Read
                    our refund policy to learn about our hassle-free return process and
                    how we ensure your satisfaction
                  </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="position-relative z-1 overflow-hidden terms-content pb-100 pt-100">
        <div className="container">
          <p>
            All sales are final and non-refundable due to the nature of the data
            sold. If you have any questions about our terms of service or refund
            policy, please call or email us before placing your order. You will
            enter into a signed agreement by placing your order and submitting
            all of your information. This was done to safeguard the authenticity
            of our databases against any potential fraud on our website.
          </p>
          <h4 className="mt-10 mb-5">Here are our terms:</h4>
          <ul>
            <li>
              I give the website the full authority to charge me the full amount
              for any and all products purchased from the website.
            </li>
            <li>
              I understand that none of the products bought from the website are
              guaranteed in terms of response rate or accuracy.
            </li>
            <li>
              I understand that all sales are final or that there are no refunds
              on products bought from the website. There will be no refunds for
              streaming dedicated servers (Infi Stream), dedicated servers, VPS
              servers, or cloud servers.
            </li>
            <li>
              If we receive any spam complaints, phishing complaints or abuse
              complaints, we can instantly suspend or terminate the server.
            </li>
            <li>
              We provide a 30-day money-back guarantee only in the event of
              server hardware failure and technical team support issues. We do
              not provide warranties for software or development issues and
              there will be no refunds in these cases.
            </li>
            <li>
              If we relocate any website to our server and developmental
              problems arise, the client must resolve those issues with the
              assistance of his or her developers; we would not be responsible
              for any development problems that arise after the migration. As a
              result, there will be no refunds for development-related issues.
            </li>
          </ul>
          <span className="text-warning">* If you do not agree with these terms and our refund policy then please do not proceed.</span>
        </div>
      </section>
    </>
  );
}
